import { displayMessage } from "../../../services/helper"
import {Form, Select, Modal} from "antd"
import { MultiSelect } from "../../../components/selects/MultiSelect";
import { useContext } from "react"
import GeneralContext from "../../../context/GeneralContext/GeneralContext";
import ELanguages from "../../../enums/ELanguages";
import SL_Button from "../../../components/buttons/Button";
import api from "../../../services/api";
const AddExercise = ({loadProtocolDetails, setIsModalAddExerciseVisible, isModalAddExerciseVisible, setLanguage, language, mountExerciseOptions, handleOnSelectExercise}) => {
    const {Option} = Select
    const [form] = Form.useForm()
    const {setShowLoading, windowHeight, currentProtocol} = useContext(GeneralContext)
    const addNewExercise = async (data) => {

        setShowLoading(true)
        const payload = {
            name: currentProtocol.name,
            addExercises: data.exercise.map((e) => e.value)
        }
        await api.protocols.update(currentProtocol.id,payload)
        setShowLoading(false)
        setIsModalAddExerciseVisible(false)
        alert(displayMessage('EXERCISE_SUCCESSFULLY_ADDED'), 'success')
        loadProtocolDetails()
    }
    return (
        <Modal
            title={<div className="text-xl font-bold text-appian-blue">{displayMessage('ADD_NEW_EXERCISE')} </div>}
            visible={isModalAddExerciseVisible}
            onCancel={() => setIsModalAddExerciseVisible(false)}
            centered={true}
            footer={[]}
            width={750}
            style={{ position: 'relative' }}
            bodyStyle={{ maxHeight: windowHeight * 0.8, overflow: 'auto' }}
        >
            <Form
                form={form}
                className='w-full flex flex-col gap-2 p-5'
                onFinish={addNewExercise}
                layout="vertical"
            >
                <div style={{ display: 'flex', flexDirection: 'column', gap: 5, alignItems: 'start' }}>
                {/* <Form.Item
                    name="protocol"
                    label={displayMessage('PROTOCOL')}
                >
                    <Input 
                        style={{ width: '100%' }} 
                        defaultValue={currentProtocol.name}
                        disabled={true}
                    />
                </Form.Item> */}
<Form.Item
label={displayMessage("LANGUAGE")}
  rules={[
    { required: true, message: displayMessage('LANGUAGE_MANDATORY') },
  ]}
name="language"
className={`w-full flex`}
style={{ flex: 1 }}
>
<Select
onChange={(code) => {
const selected = Object.values(ELanguages).find(lang => lang.code === code);
setLanguage(selected.code);
}}
value={language.code}
allowClear
placeholder={displayMessage('LANGUAGE')}
>
{Object.values(ELanguages).map((type) => (
<Option key={type.code} value={type.code}>
  {type.description}
</Option>
))}
</Select>
</Form.Item>
                <Form.Item
                    label={displayMessage('EXERCISE')}
                    name="exercise"
                    className={`w-full flex`}
                    style={{ flex: 1 }}
                    rules={[
                        { required: true },
                    ]}
                >
                    <MultiSelect
                        mode="multiple"
                        allowClear
                        fetchOptions={async e => mountExerciseOptions(e)}
                        placeholder={displayMessage('SELECT_ONE_OR_MULTIPLES_EXERCISE')}
                        onChange={handleOnSelectExercise}
                    />
                </Form.Item>
                    
                </div>

                <SL_Button
                    type="primary"
                    size='large'
                    htmlType="submit"
                    className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                >
                    {displayMessage('CREATE_EXERCISE')}
                </SL_Button>

            </Form>
        </Modal>
    )
}

export default AddExercise